import React from 'react'
import LogoImage from '../../image/logo.png'

export interface IOwnProps {

}

export type IProps = IOwnProps

const Logo:React.FC<IProps> = (props) => {
  return (
    <img
      src={LogoImage}
      alt='Logo'
      width='121'
      height='27'
    />
  )
}

export default Logo
